import _ from 'underscore';

import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SchemasListingSchema} from 'schemas/SchemasListing';

export default function filterAndSortAssaySchemas<T extends SchemasListingSchema>(
  assaySchemas: Array<T>,
  schemaType: LegacyAssaySchemaType
): Array<T> {
  const assaySchemasOfType = _.where(assaySchemas, {schemaType});
  return _.sortBy(assaySchemasOfType, ({name}) => name.toLowerCase());
}
